import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  // All Colors
  palette: {
    primary: {
      main: "#7922D8",
      light: "#F3EBFF",
    },
    secondary: {
      main: "#000000",
      light: "#ffffff",
    },
    custom: {
      white: "#ffffff",
      black: "#000000",
      blue: "#473BF0",
      softGrey: "#D6D6D7",
      slateGrey: "#8692A6",
      darkGrey: "#525252",
      tartOrange: "#EA580C",
      pantoneGreen: "#08AD36",
      venetianRed: "#CC1512",
      silverChalice: "#A6A9AC",
      borderColor: "#e9e9e9",
      crayolaGrey: "#868E96",
      errorRed: "#d32f2f",
    },
    background: {
      primary: "#f3e8fd",
      primary01: "#7814D91A",
      primary02: "#f5ecff",
      secondary: "#FFFFFF",
      white: "#ffffff",
      offWhiteGrey: "#F0F0F0",
      darkBlue: "#1E263B",
      black05: "#00000005",
      black08: "#00000008",
      lightGrey: "#F7F7F7",
      lightGrey01: "#f8f8f8",
      lightGrey02: "#EDEDED",
      lightGrey03: "#F9F9F9",
      lightGrey04: "#FAF9F6",
      green01: "#32CD32",

    },
    gradient: {
      main: "linear-gradient(46.79deg, #7922D8 0%, #000000 68.04%)",
      footer: "linear-gradient(225deg, #313C59 0%, #161C2D 100%);",
      authBg:
        "linear-gradient(225.17deg, #7B11F9 0.3%, #7922D8 39.59%, #3636B2 100%)",
    },
  },

  typography: {
    color: "#000000",
    fontFamily: ["Roboto", "Poppins", "Inter", "sans-serif"].join(","),

    // custom typography
    auth_primary_text: {
      fontFamily: "Roboto",
      fontWeight: 700,
      fontSize: "2rem",
      color: "#000000",
      lineHeight: 1.5,
      textAlign: "center",
    },
    auth_secondary_text: {
      fontFamily: "Roboto",
      fontWeight: 400,
      fontSize: "1rem",
      color: "#8692A6",
      lineHeight: 1.5,
      textAlign: "center",
    },
  },
  // override styled of components;

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "Roboto",
          textTransform: "capitalize",
          borderRadius: "6px",
          width: "100%",
          height: "100%",
          boxShadow: "none",
          // padding: "10px",
        },
        contained: {
          backgroundColor: "#7922D8",
          color: "#ffffff",
          fontSize: "1rem",
          fontWeight: 400,
          border: "2px solid #7922D8",
          "&:hover": {
            backgroundColor: "#7922D8",
            boxShadow: "none",
          },
        },
        outlined: {
          backgroundColor: "transparent",
          color: "#7922D8",
          fontSize: "1rem",
          fontWeight: 400,
          border: "2px solid #7922D8",
          "&:hover": {
            backgroundColor: "transparent",
            border: "2px solid #7922D8",
            boxShadow: "none",
          },
        },
        custom_outlined: {
          backgroundColor: "transparent",
          color: "#8692A6",
          fontSize: "1rem",
          fontWeight: 400,
          border: "2px solid #8692A6",
          "&:hover": {
            backgroundColor: "transparent",
            border: "2px solid #8692A6",
            boxShadow: "none",
          },
        },

        error_outlined: {
          backgroundColor: "transparent",
          color: "rgb(197, 6, 28)",
          fontSize: "0.875rem",
          fontWeight: 500,
          border: "1px solid rgb(197, 6, 28)",
          borderRadius: "6px",
          boxShadow: "none",
          "&:hover": {
            backgroundColor: "rgba(197, 6, 28, 0.08)", // halka red hover
            border: "1px solid rgb(192, 13, 34)",
            color: "rgb(192, 13, 34)",
            boxShadow: "none",
          },
        },

        export_button: {
          fontWeight: 400,
          fontSize: "0.875rem",
          color: "#8692A6",
          backgroundColor: "transparent",
          border: "1px solid #8692A6",
          borderRadius: "5px",
          height: 35,
          width: "auto",
          "&:hover": {
            backgroundColor: "transparent",
            border: "1px solid #8692A6",
            boxShadow: "none",
          },
        },

        add_attribute_button: {
          fontWeight: 400,
          fontSize: "0.875rem",
          color: "#000000",
          backgroundColor: "#f8f4fa",
          border: "1px solid rgb(204, 193, 209)",
          borderRadius: "5px",
          padding: "6px 12px",
          "&:hover": {
            backgroundColor: "#d9d5db",
            border: "1px solid rgb(204, 193, 209)",
            boxShadow: "none",
          },


        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        size: "small",
      },
      styleOverrides: {
        root: {
          "&.MuiFormControl-root .MuiOutlinedInput-root .MuiInputBase-input": {
            // padding: "8px 8px",
          },
          "& .MuiOutlinedInput-root": {
            borderRadius: 6,
            "& .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #A6A9AC`,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #A6A9AC`,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #A6A9AC`,
            },
            // ✅ Error state
            "&.Mui-error .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #d32f2f`,
            },
            "&.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #d32f2f`,
            },
            "&.Mui-error:hover .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #d32f2f`,
            },
          },
          "& .MuiFormHelperText-root": {
            marginLeft: 0,
            marginTop: 0,
            "&.Mui-error": {
              color: "#d32f2f",
            },
          },
          "& .Mui-disabled": {
            cursor: "not-allowed",
          },
        },
      },
    },
  },
});

export default theme;
